import { module } from 'angular';
import { react2angular } from 'react2angular';

import { StageFailureMessage } from './StageFailureMessage';

export const STAGE_FAILURE_MESSAGE_COMPONENT = 'spinnaker.core.pipeline.stageFailureMessage.component';
module(STAGE_FAILURE_MESSAGE_COMPONENT, [])
  .component('stageFailureMessage', react2angular(StageFailureMessage, ['message', 'messages', 'stage']));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/pipeline/details/stageFailureMessage.component.ts